import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { Location, StaticRouter } from 'react-router';
import { getBlockComponent } from '../../lib/BlockUtils/BlockUtils';
import validOn2PartialBlocks from './validOn2PartialBlocks';
import { Block } from '../../types/api/Block';
import { windowLogger } from '../../_lib/Logger/windowLogger';

function renderBlockToStaticMarkup(value: Block, location: Location) {
  // @ts-expect-error not really typed so dont care
  const component = getBlockComponent(validOn2PartialBlocks)(value);
  try {
    return ReactDOMServer.renderToStaticMarkup(
      <StaticRouter location={location}>
        <div data-unfunctional-partial-block="">{component}</div>
      </StaticRouter>
    );
  } catch (e) {
    windowLogger.warn(e);
  }
  return null;
}

function insertBlockIntoPlaceholderContainer(html: string, key: string, value: Block, location: Location): string {
  return html.replace(
    new RegExp(`<div data-replace-by="${key}"></div>`),
    `<div data-replace-by="${key}">${renderBlockToStaticMarkup(value, location)}</div>`
  );
}

export function processHTML(location: Location, html: string, partialBlocks?: Block[]): string {
  if (!partialBlocks) {
    return html;
  }

  return Object.entries(partialBlocks).reduce(
    (previousHtml: string, [key, value]: [string, Block]) =>
      insertBlockIntoPlaceholderContainer(previousHtml, key, value, location),
    html
  );
}
